<template>
<div>
    <div class="padding">
        <div id="container" v-on:click="info()">
            <div class="product-image">
                <img alt="trafikklys" v-bind:src="bilde">
            </div>

            <div class="product-details-small">
              <h2>{{ title }}</h2>
              <!-- <p>{{ text }}</p> -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  data() {
    return {
        bilde: require('../assets/aktiviteter/' + this.bildetittel),
    }
  },
  props: {
    msg: String,
    title: "",
    text: "",
    bildetittel: "",
  },
  methods: {
    info() {
      // this.$router.push('/aktiviteter-info')
      this.$router.push({ name: 'aktiviteterInfo', params: {id: this.title }})
    }
  },
}
</script>


<style scoped>

/* fonts  */
/* @import url('https://fonts.googleapis.com/css?family=Abel|Aguafina+Script|Artifika|Athiti|Condiment|Dosis|Droid+Serif|Farsan|Gurajada|Josefin+Sans|Lato|Lora|Merriweather|Noto+Serif|Open+Sans+Condensed:300|Playfair+Display|Rasa|Sahitya|Share+Tech|Text+Me+One|Titillium+Web'); */

/* Web */
@media screen and (min-width: 1001px) {
  .padding {
    padding-top: 3%;
    padding-left: 5%;
    padding-right: 5%;
  }
#container{
	box-shadow: 0 15px 30px 1px rgba(128, 128, 128, 0.31);
	background: rgba(255, 255, 255, 0.90);
	text-align: center;
	border-radius: 5px;
	overflow: hidden;
	margin: auto;
  max-width: 100vh;
  width: auto;
  height: 28vh;
    
}
#container:hover{
    transform: scale(1.1, 1.1);
}

.product-details {
	position: relative;
	text-align: right;
  overflow: hidden;
	/* padding: 30px; */
	height: 100%;
	float: center;
  /* background-color: aqua; */
}
.product-details-small {
  position: relative;
	text-align: right;
  overflow: hidden;
	padding: 10vh;
	height: 100%;
  float: center;
  /* background-color: aqua; */
}
h1{
	/* font-family: 'Old Standard TT', serif; */
  text-align: center;
	font-size: 34px;
	color: #344055;
  margin: 0%;
}
h2{
  text-align: center;
	font-size: 34px;
	color: #344055;
  margin: 0%;
  padding: 1%;
  
}
p {
	text-align: center;
	font-size: 16px;
    color: #7d7d7d;
}
}


/* Mobil */
@media screen and (max-width: 1000px) {
  .padding {
    padding-top: 3%;
    padding-left: 5%;
    padding-right: 5%;
  }
  #container{
    box-shadow: 0 15px 30px 1px rgba(128, 128, 128, 0.31);
	background: rgba(255, 255, 255, 0.90);
	text-align: center;
	border-radius: 5px;
	overflow: hidden;
    margin: auto;
    width: auto;
    height: 20vh;
  }

  .product-details {
	position: relative;
	text-align: right;
    overflow: hidden;
	height: 100%;
    float: center;
}
.product-details-small {
    position: relative;
	text-align: right;
    overflow: hidden;
    height: 100%;
    float: center;
    padding: 6vh;
}
h2{
    text-align: center;
	font-size: 25px;
	color: #344055;
    margin: 0%;
    padding: 1%;
}
p {
	text-align: center;
	font-size: 16px;
    color: #7d7d7d;
}
}

/* product image  */
.product-image {
	/* transition: all 0.3s ease-out; */
	display: inline-block;
	position: relative;
	overflow: hidden;
	height: 100%;
    /* float: right; */
    float: left;
    width: auto;
    /* width: 100%; */
    display: inline-block;
    /* background-color: #344055; */
}

#container img {
    width: auto;
    height: 100%;
    }



</style>
